const form = document.querySelector('#review');
const inputElement = document.querySelector('.review__range input');
const openModalElement = document.querySelector('.review__button--modal');
const submitElement = document.querySelector('.review__button--submit');
const modalBackground = document.querySelector('.review__overlay');
const closeModalElement = document.querySelector('.review__modal-close');
const plusElement = document.querySelector('.review__plus');
const minusElement = document.querySelector('.review__minus');
const emailField = document.querySelector('#review-email');

if (form && inputElement && openModalElement && submitElement && emailField) {
    inputElement.addEventListener('change', () => {
        updatePoints(inputElement.value);
    });

    if (plusElement) {
        plusElement.addEventListener('click', () => {
            inputElement.value = parseInt(inputElement.value) + 1;
            updatePoints(inputElement.value);
        });
    }
    if (minusElement) {
        minusElement.addEventListener('click', () => {
            inputElement.value = parseInt(inputElement.value) - 1;
            updatePoints(inputElement.value);
        });
    }
    if (closeModalElement && modalBackground) {
        openModalElement.addEventListener('click', () => {
            modalBackground.style.display = 'flex';
        });

        closeModalElement.addEventListener('click', () => {
            modalBackground.style.display = 'none';
        });
    }
}

function updatePoints(value) {
    value = parseInt(value);
    if (value < 0 || value > 10) return;

    //  Button + Email field
    if (value < 9) {
        openModalElement.style.display = 'block';
        submitElement.style.display = 'none';
        emailField.required = true;
    } else {
        openModalElement.style.display = 'none';
        submitElement.style.display = 'block';
        emailField.required = false;
    }

    // Stars

    [...document.querySelectorAll('.review__star')].forEach((star) => {
        star.classList.remove('active');
        star.classList.remove('half-active');
    });

    // even

    switch (value) {
        case 10:
            [...document.querySelectorAll('.review__star--5')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
        case 8:
            [...document.querySelectorAll('.review__star--4')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
        case 6:
            [...document.querySelectorAll('.review__star--3')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
        case 4:
            [...document.querySelectorAll('.review__star--2')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
        case 2:
            [...document.querySelectorAll('.review__star--1')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
    }

    // odd

    switch (value) {
        case 9:
            [...document.querySelectorAll('.review__star--5')].forEach(
                (star) => {
                    star.classList.add('half-active');
                }
            );
            [...document.querySelectorAll('.review__star--1')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
            [...document.querySelectorAll('.review__star--2')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
            [...document.querySelectorAll('.review__star--3')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
            [...document.querySelectorAll('.review__star--4')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
            break;
        case 7:
            [...document.querySelectorAll('.review__star--4')].forEach(
                (star) => {
                    star.classList.add('half-active');
                }
            );
            [...document.querySelectorAll('.review__star--1')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
            [...document.querySelectorAll('.review__star--2')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
            [...document.querySelectorAll('.review__star--3')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
            break;
        case 5:
            [...document.querySelectorAll('.review__star--3')].forEach(
                (star) => {
                    star.classList.add('half-active');
                }
            );
            [...document.querySelectorAll('.review__star--1')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
            [...document.querySelectorAll('.review__star--2')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
            break;
        case 3:
            [...document.querySelectorAll('.review__star--2')].forEach(
                (star) => {
                    star.classList.add('half-active');
                }
            );
            [...document.querySelectorAll('.review__star--1')].forEach(
                (star) => {
                    star.classList.add('active');
                }
            );
            break;
        case 1:
            [...document.querySelectorAll('.review__star--1')].forEach(
                (star) => {
                    star.classList.add('half-active');
                }
            );
            break;
    }
}
